import { Injectable } from '@angular/core';
import { ServiceStock } from './service-stock.service';
import { SocketioService } from './socketio.service';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class MarketWatchService {

  socketId = '';

  constructor(private services: ServiceStock, private socketio: SocketioService) { }

  // INDEX Related Websockets
  getIndexMaster() {
    return this.socketio.listen('INDEXMASTER.RSP');
  }

  getIndexInitData() {
    return this.socketio.listen('INDEXDETAILS.SUBS.RSP');
  }

  getIndex() {
    return this.socketio.listen('INDEX');
  }

  getIndexDetails() {
    return this.socketio.listen('INDEXDETAILS');
  }

  tickerSubs() {
    this.socketio.emit("TICKER.SUBS", "");
  }

  tickerUnSubs() {
    this.socketio.emit("TICKER.UNSUBS", "");
  }

  getTickerInfo() {
    return this.socketio.listen('TICKERINTO');
  }

  // Market Related Websockets
  getMarketStats() {
    //console.log("MIS inside getMarketStats");
    return this.socketio.listen('MKTSTATS');
  }

  getMarketPhase() {
    //console.log("PHASE MIS inside getMarketPhase");
    
    /*this.socketio.listen('MKTPHASE').subscribe((data: any) => {
      console.log("PHASE data in market whatch",data);
    });*/
    return this.socketio.listen('MKTPHASE');
  }

  marketWatchStockSubs(data, topic = 'MW.IWS.STOCKS.SUBS') {
    //console.log("[%s] " + topic + " Sent", new Date());
    console.log("MW.IWS.STOCKS.SUBS: ", data);
    // this.socket.emit('MW.IWS.STOCKS.SUBS', '[{"Symbol":"1JANATAMF","Exch":"CTG","Product":"EQUITY"}]');
    if (data.length > 0) {
      this.socketio.emit(topic, JSON.stringify(data));
    }
  }

  getMarketWatchStockResp() {
    //console.log("MISData inside getMarketWatchStockResp");
    this.socketio.listen('MW.IWS.STOCKS.SUBS.RSP').subscribe((resp: any) => {
      //console.log("MISData inside getMarketWatchStockResp1",resp);
      this.processMarketResponse(resp, "ExchSymbol");
    });
  }

  getMarketData() {
    this.socketio.listen('MARKETDATA').subscribe((resp: any) => {
      console.log("MISData inside MARKETDATA");
      console.log("MISData resp.Segment",resp.Segment);
      if (resp.Segment == "All") {
        let respObj = [resp.DataObject];
        console.log("MISData inside MARKETDATA1");
        this.processMarketResponse(respObj, "Symbol");
      }
    });
  }

  unSubscribeMarket(data) {
    // this.services.dataStore.subbedStocks
    //console.log("data in unsubscribe.....",data);
    if (data.length > 0) {
      this.socketio.emit('MW.IWS.STOCKS.UNSUBS', JSON.stringify(data));
    }
    // this.socket.removeAllListeners("MW.IWS.STOCKS.SUBS.RSP");
    // this.socket.removeAllListeners("MARKETDATA");
    // this.socket.removeAllListeners("details");
  }

  processMarketResponse(resp, exchSymbolField) {
    //console.log("MISData MARKETDATA REceived");
   
    let exchSymbolKey = "";
    resp.forEach(respObj => {
      //console.log("MIS respObj.StockHeader",respObj);
      if(respObj.StockHeader.Product == 2){
        respObj.StockHeader.Product = "COMDERV";
      }else if(respObj.StockHeader.Product == 13){
        respObj.StockHeader.Product = "FUTOPT";
      }
      exchSymbolKey = respObj.StockHeader.Exch + "#" + respObj.StockHeader.Product + "#" + respObj.StockHeader[exchSymbolField];

       //console.log("MIS MARKETDATA key", exchSymbolKey, respObj.StockHeader.Symbol);

      if (this.services.dataStore.stockMasterMap.has(exchSymbolKey)) {
        //console.log("MIS symbol matches..",respObj.StockHeader);
        let el = this.services.dataStore.stockMasterMap.get(exchSymbolKey);
        // console.log("MARKETDATA el", el);

        //console.log("respObj.TouchLine",respObj.TouchLine);
        if (respObj.TouchLine != null) {
          if (respObj.TouchLine.BuyQty != null)
            el["buyQty"] = respObj.TouchLine.BuyQty; // Column 7

          //console.log("MIS respObj.TouchLine.Product",respObj.TouchLine.Product);
          if (respObj.TouchLine.Product != null){
            if(respObj.TouchLine.Product == 2){
              el["product"] = "COMDERV";
            }
            if(respObj.TouchLine.Product == 13){
              el["product"] = "FUTOPT";
            }
          }

          if (respObj.TouchLine.BuyPrice != null)
            el["buyPrice"] = parseFloat(respObj.TouchLine.BuyPrice).toFixed(2); // Column 8

          if (respObj.TouchLine.SellQty != null)
            el["sellQty"] = respObj.TouchLine.SellQty // Column 9

          if (respObj.TouchLine.SellPrice != null)
            el["sellPrice"] = parseFloat(respObj.TouchLine.SellPrice).toFixed(2); // Column 10

          if (respObj.TouchLine.TradePrice != null)
            el["lastPrice"] = parseFloat(respObj.TouchLine.TradePrice).toFixed(2); // Column 11

          if (respObj.TouchLine.HighPrice != null)
            el["highPrice"] = parseFloat(respObj.TouchLine.HighPrice).toFixed(2); // Column 25

          if (respObj.TouchLine.LowPrice != null)
            el["lowPrice"] = parseFloat(respObj.TouchLine.LowPrice).toFixed(2); // Column 26
        }

        if (respObj.TradeInfo != null) {
          if (respObj.TradeInfo.NetChangePercentage != null)
            el["netChangePercentage"] =  parseFloat(respObj.TradeInfo.NetChangePercentage).toFixed(2); // Column 12

          if (respObj.TradeInfo.NetChangeValue != null)
            el["netChangeValue"] =  parseFloat(respObj.TradeInfo.NetChangeValue).toFixed(2); // Column 22//Removed Number()

          if (respObj.TradeInfo.LastTradeTime != null)
            el["lastTradeTime"] = respObj.TradeInfo.LastTradeTime; // Column 23

          if (respObj.TradeInfo.TradeQty != null)
            el["tradeQty"] = respObj.TradeInfo.TradeQty; // Column 24
        }

        if (respObj.VolumeInfo != null) {
          if (respObj.VolumeInfo.TotalTradeQty != null)
            el["volume"] = parseFloat(respObj.VolumeInfo.TotalTradeQty).toFixed(2); // Column 13 //added by shanmuga priya

          if (respObj.VolumeInfo.TotalBuyQty != null)
            el["totalBuyQty"] = respObj.VolumeInfo.TotalBuyQty; // Column 20

          if (respObj.VolumeInfo.TotalSellQty != null)
            el["totalSellQty"] = respObj.VolumeInfo.TotalSellQty; // Column 21

        }

        if (respObj.DayTradeInfo != null) {
          if (respObj.DayTradeInfo.TotalDayTrades != null)
            el["noOfTrades"] = respObj.DayTradeInfo.TotalDayTrades; // Column 18

          if (respObj.DayTradeInfo.TotalDayTradedValue != null)
            el["turnover"] = parseFloat(respObj.DayTradeInfo.TotalDayTradedValue).toFixed(2); // Column 14
        }

        if (respObj.CloseInfo != null) {
          //console.log("MIS respObj.CloseInfo.PreviousClosePrice",respObj.CloseInfo.PreviousClosePrice);
          if (respObj.CloseInfo.PreviousClosePrice != null)
            el["prevClose"] = parseFloat(respObj.CloseInfo.PreviousClosePrice).toFixed(2); // Column 15

          if (respObj.CloseInfo.ClosePrice != null)
            el["close"] = parseFloat(respObj.CloseInfo.ClosePrice).toFixed(2); // Column 19
        }

        if (respObj.StockHeader.LMT != null) {
          el["lastModTime"] = this.services.timePipe.transform(respObj.StockHeader.LMT); // Column 16
        }

        if (respObj.BuyVWAPInfo != null) {
          if (respObj.BuyVWAPInfo.VWAPBuyPrice != null)
            el["buyVWAP"] = respObj.BuyVWAPInfo.VWAPBuyPrice;   // BuyVWAP is shown in Market Depth Screen
        }

        if (respObj.SellVWAPInfo != null) {
          if (respObj.SellVWAPInfo.VWAPSellPrice != null)
            el["sellVWAP"] = respObj.SellVWAPInfo.VWAPSellPrice;   // SellVWAP is shown in Market Depth Screen
        }

        //if (respObj.TouchLine.BuyQty != null)
        el["change"] = "";//respObj.TouchLine.BuyQty; //this has to change // Column 17

        //el.bsPressure = respObj.TouchLine.BuyQty;
        el["buyPressure"] = (el.totalBuyQty / (el.totalBuyQty + el.totalSellQty)) * 100.0; // Column 27
        // console.log("BS Pressure", el.totalBuyQty, el.totalSellQty)
        // el.buyPressure = 40;
        // el.sellPressure = 100 - el.buyPressure; 
        el["sellPressure"] = (el.totalSellQty / (el.totalBuyQty + el.totalSellQty)) * 100.0;// Column 27
        //console.log("respObj.YearHighLow",respObj.YearHighLow);
        if(respObj.YearHighLow != null){
          el["WeeksHigh52"] = respObj.YearHighLow.WeeksHigh52;
        }
        // console.log("el.sellPressure", el.totalBuyQty, el.totalSellQty, el.buyPressure, el.sellPressure);
        // double buyPressure = (totalBuyQty / (totalBuyQty + totalSellQty)) * 100.0;
        // double sellPressure = (totalSellQty / (totalBuyQty + totalSellQty)) * 100.0;
        // }

        //console.log("respObj.StockHeader.ExpiryDate",respObj.StockHeader.ExpiryDate);
        if (respObj.StockHeader.ExpiryDate != null){
          respObj.StockHeader.ExpiryDate = this.services.timePipe.dateConversion2(respObj.StockHeader.ExpiryDate);
          //el["expirydate"] = respObj.StockHeader.ExpiryDate; // Column 28 //added by pooja 
          el["expiryDate"] = respObj.StockHeader.ExpiryDate; //added by shanmuga priya
        }

        if (respObj.BidInfo != undefined && respObj.BidInfo != null) {
          let bidList = [];
          respObj.BidInfo.forEach(priceInfo => {
            let bidInfo = {};
            bidInfo["bidOrder"] = priceInfo.Orders;
            //console.log(" bidinfo price...",priceInfo.Price);
            bidInfo["bidPrice"] = Number(priceInfo.Price).toFixed(2);
            bidInfo["bidQty"] = priceInfo.Qty;

            bidList.push(bidInfo);
          });
          el["bidList"] = bidList;
        }

        if (respObj.OfferInfo != undefined && respObj.OfferInfo != null) {
          let askList = [];
          respObj.OfferInfo.forEach(priceInfo => {
            let offerInfo = {};
            offerInfo["offerOrder"] = priceInfo.Orders;
            //console.log(" offerInfo price...",priceInfo.Price);
            offerInfo["offerPrice"] = Number(priceInfo.Price).toFixed(2);
            offerInfo["offerQty"] = priceInfo.Qty;

            askList.push(offerInfo);
          });
          el["askList"] = askList;
        }
      }else{
        console.log("MIS Symbol doesnot match");
      }
    });
  }

  getStockQuote(exchange, product, symbol, board = "NR") {
    let inputMap = new Map();
    inputMap.set('Body.exchange', exchange);
    inputMap.set('Body.product', product);
    inputMap.set('Body.symbol', symbol);
    this.services.http.fetchApi('/stock/quote', 'POST', inputMap).subscribe(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
        var respCode: any = res['respCode'];
        if (respCode != null && respCode == 0) {
          let resObj = res['response'][0];

          let stockKey = exchange + "#" + product + "#" + board + "#" + symbol;
          if (this.services.dataStore.stockMasterMap.has(stockKey)) {
            let selectedStock = this.services.dataStore.stockMasterMap.get(stockKey);
            selectedStock["highPrice"] = resObj.high;
            selectedStock["lowPrice"] = resObj.low;
            selectedStock["volume"] = resObj.totalqty;
            selectedStock["turnover"] = resObj.todaystotaltadedValue;
            selectedStock["totalBuyQty"] = resObj.totalbuyqty;
            selectedStock["totalSellQty"] = resObj.totalsellqty;
            selectedStock["prevClose"] = resObj.ycp;
            selectedStock["lastPrice"] = resObj.ltp;

            selectedStock["open"] = resObj.open;
            selectedStock["close"] = resObj.close;
            selectedStock["circuitHigh"] = resObj.upperCircuitLimit;
            selectedStock["circuitLow"] = resObj.lowerCircuitLimit;
            selectedStock["tradeQty"] = resObj.ltq;
            selectedStock["buyVWAP"] = resObj.vWAPBuyPrice;
            selectedStock["sellVWAP"] = resObj.vWAPSellPrice;

            if (resObj.ltt != null && resObj.ltt > 0) {
              selectedStock["lastTradeTime"] = this.services.timePipe.transform(resObj.ltt);
            }

            if (resObj.bidDepthList != undefined && resObj.bidDepthList.length > 0) {
              selectedStock["bidList"] = resObj.bidDepthList;
            }

            if (resObj.offerDepthList != undefined && resObj.offerDepthList.length > 0) {
              selectedStock["askList"] = resObj.offerDepthList;
            }
          }
        }
      },
      async (httpError) => {
        var err = httpError['error']
        if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
        }
      }
    );
  }
}
